module.exports = __webpack_public_path__ + "img/Bodice-Back-Jb-Kd-La.a436ce2e.png";